export default __webpack_public_path__ + "static/11-2--bb603979d5b0964bed34210322663c65.png";